import React from 'react';
import createReactClass from 'create-react-class';
import request from '../../helpers/request';
import purchaseSuggestionConfig from './config/purchaseSuggestionConfig';
import setViewTitle from '../../helpers/setViewTitle';
import sendNotification from '../../helpers/sendNotification';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';
import CommentsWidget from '../common/CommentsWidget';
import DocumentsCollection from '../common/DocumentsCollection';

var ConfirmPurchaseSuggestionMayor = createReactClass({

  getInitialState() {
    return {
      suggestion: {
        lines: [],
        newLines: [],
      }
    };
  },

  componentWillMount() {
    setViewTitle('Genehmigung Bürgermeister');
  },

  componentDidMount() {
    request.get({
      url: purchaseSuggestionConfig.apiUrl + this.props.match.params.suggestionId,
      success: suggestion => {
        if (this.isMounted()) {
          this.setState({
            suggestion: suggestion
          });
        }
      }
    });
  },

  handleSubmit(e) {
    e.preventDefault();

    request.post({
      url: purchaseSuggestionConfig.apiUrl + this.state.suggestion.suggestionId + '/confirm',
      data: { id: this.state.suggestion.id },
      success: () => {
        sendNotification('Bestellung(en) wurden genehmigt');
        this.props.history.push('/purchasesuggestions/overview');
      }
    });
  },

  handleReject(e) {
    e.preventDefault();

    var suggestion = this.state.suggestion;

    request.post({
      url: purchaseSuggestionConfig.apiUrl + this.state.suggestion.suggestionId + '/reject',
      data: suggestion,
      success: () => {
        sendNotification('Die Buchhaltung wurde über die abgelehnte Genehmigung informiert');
        this.props.history.push('/purchasesuggestions/overview');
      }
    });
  },

  enrichNewComment(newComment) {
    newComment.suggestionId = this.props.match.params.suggestionId;
    return newComment;
  },

  onDocumentDeleted(document) {
    const suggestion = this.state.suggestion;
    const documentIndexToDelete = suggestion.documents.findIndex(x => x.id === document.id);

    if (documentIndexToDelete >= 0) {
      suggestion.documents.splice(documentIndexToDelete, 1);
      this.setState({suggestion});
    }
  },

  onDocumentUploaded(document) {
    const suggestion = this.state.suggestion;
    suggestion.documents.push(document);
    this.setState({suggestion});
  },

  render() {
    var displayLines = this.state.suggestion.lines.map(line =>
      <tr key={line.itemId}>
          <td>{line.itemName}</td>
          <td>{line.vendorName}</td>
          <td>{line.purchaseUnitQuantity}</td>
          <td>{line.purchaseUnitName}</td>
          <td>{line.lineNetPrice}</td>
      </tr>
    );

    const displayNewLines = this.state.suggestion.newLines.map(line =>
      <tr key={line.itemName}>
          <td>{line.itemName}</td>
          <td>{line.vendorName}</td>
          <td>{line.purchaseUnitQuantity}</td>
          <td>{line.purchaseUnitName}</td>
          <td>{line.lineNetPrice}</td>
      </tr>
    );

    const formTitle = this.state.suggestion.orderWithoutStorage ? 'Zu genehmigender Bestellvorschlag ohne Lagerführung' : 'Zu genehmigender Bestellvorschlag';

    const bestellvorschlagBody = this.state.suggestion.orderWithoutStorage ? (
      <div style={{ padding: '10px' }}>
        <strong style={{ marginRight: '.5em' }}>Bestellsumme:</strong>
        <span>€ {this.state.suggestion.price}</span>
      </div>
    ) : (
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead>
          <tr>
            <th>Artikel</th>
            <th>Lieferant</th>
            <th>Bestellmenge</th>
            <th>Bestelleinheit</th>
            <th>Preis</th>
          </tr>
          </thead>
          <tbody>
          {displayLines}
          {displayNewLines}
          </tbody>
        </table>
      </div>);

    return (
        <div>
          <div className="jarviswidget jarviswidget-color-blueDark" data-widget-editbutton="false">
            <header>
              <span className="widget-icon"> <i className="fa fa fa-lg fa-file-archive-o"></i> </span>
              <h2>{formTitle}</h2>
            </header>
            <div>
              <div className="jarviswidget-editbox"></div>
              <div className="widget-body no-padding" style={{ minHeight: 'auto' }}>
                {bestellvorschlagBody}
                <div className="widget-footer">
                  <input type="button" className="btn btn-primary" value="Genehmigen" disabled={this.props.isAjaxInProgress} onClick={this.handleSubmit}/>
                  <input type="button" className="btn btn-danger" value="Ablehnen" disabled={this.props.isAjaxInProgress} onClick={this.handleReject}/>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <CommentsWidget
              apiUrl={`purchasesuggestions/${this.props.match.params.suggestionId}/comments`}
              containerClassName="col-md-12"
              beforeSubmit={newComment => this.enrichNewComment(newComment)}
              claim="purchasesuggestions:mayor"
            />
          </div>
          <div className="row">
            <DocumentsCollection
              documents={this.state.suggestion.documents}
              onDoumentDeleted={this.onDocumentDeleted}
              onDocumentUploaded={this.onDocumentUploaded}
              deleteUrlBase={`${purchaseSuggestionConfig.apiUrl}${this.props.match.params.suggestionId}`}
              viewUrlBase={`${purchaseSuggestionConfig.apiUrl}${this.props.match.params.suggestionId}`}
              uploadUrlBase={`${purchaseSuggestionConfig.apiUrl}${this.props.match.params.suggestionId}`}
              claim="purchasesuggestions:mayor"
            />
          </div>
        </div>
    );
  }

});

export default AjaxInProgressHOC(ConfirmPurchaseSuggestionMayor);



// WEBPACK FOOTER //
// ./src/components/purchasesuggestions/ConfirmPurchaseSuggestionMayor.js